import React from 'react';
import PropTypes from 'prop-types';
import {OtpPopup, agentDeveloperUtils} from 'wobi-web-common';
import {injectIntl} from 'react-intl';
import {getOffersFields, setOffersFields} from '../utils/persistOfferDetails';
import {getToken, validateSecret} from '../utils/apiHandlers';
import {fireGtmEvent} from '../utils/marketingUtils';

const OtpContainer = ({open, handleClose, handleVerified, handleBlocked, otpMethods, intl}) => {
  const [tokenReceived, setTokenReceived] = React.useState(false);
  const [tokenLoading, setTokenLoading] = React.useState(false);
  const [verifyLoading, setVerifyLoading] = React.useState(false);
  const [commonError, setCommonError] = React.useState('');
  const [token, setToken] = React.useState(false);
  const [sentOtpMethod, setSentOtpMethod] = React.useState('');
  const retryCount = React.useRef(0);
  const messages = (id) => intl.formatMessage({id});

  const handlePostOtpDetails = details => {
    setTokenLoading(true);
    fireGtmEvent('homeSendOtp', {OtpType: details.otpMethod});
    setSentOtpMethod(details.otpMethod);
    window.rollbar.info(`homeSendOtp ${details.otpMethod} request was fired`);
    details.agentDeveloperName = agentDeveloperUtils.getAgentDeveloperName;
    details.webOTP = true;
    getToken({...details, retryCount: retryCount.current})
      .then(res => {
        setOffersFields({
          firstname: details.fullname.split(' ')[0],
          lastname: details.fullname.split(' ')[1],
          otpMethod: details.otpMethod,
          phone: details.phoneNumber,
          retryCount: retryCount.current,
        });
        if (res.success) {
          setToken(res.data);
          setOffersFields({
            token: res.data,
          });
          setTokenLoading(false);
          setTokenReceived(true);
        } else if (!res.success && res.message === 'blocked user') {
          handleClose();
          handleBlocked();
          setTokenLoading(false);
        }
      })
      .catch(() => {
        setTokenLoading(false);
        setCommonError('Something wrong on details request');
      });
  };

  const handleVerify = data => {
    const request = Object.assign({}, {secret: data.code, token});
    setVerifyLoading(true);
    fireGtmEvent('homeConfirmOtp', {OtpType: getOffersFields('otpMethod')});
    validateSecret(request)
      .then(res => {
        setVerifyLoading(false);
        if (res.success) {
          handleClose();
          handleVerified();
        } else if (!res.success && res.message === 'wrongOtp') {
          setCommonError(messages('otp_container.error_wrong_otp'));
        } else if (!res.success && res.message === 'maxAttempts') {
          setCommonError(messages('otp_container.error_max_attempts'));
          handleResend(sentOtpMethod);
        }
      })
      .catch(() => {
        setVerifyLoading(false);
        setCommonError(messages('error_something_wrong_on_details_request'));
      });
  };

  const handleResend = (otpMethod) => {
    setSentOtpMethod(otpMethod);
    retryCount.current++;
    fireGtmEvent('homeOtpSendAgain', {OtpType: otpMethod});
    window.rollbar.warning(`homeOtpSendAgain ${otpMethod} request was fired`);
    getToken({
      agentDeveloperName: agentDeveloperUtils.getAgentDeveloperName,
      fullname: `${getOffersFields('firstname')} ${getOffersFields(
        'lastname',
      )}`,
      otpMethod,
      phoneNumber: getOffersFields('phone'),
      retryCount: retryCount.current,
      webOTP: true,
    })
      .then(res => {
        if (res.success) {
          setToken(res.data);
          setOffersFields({token: res.data});
        }
      })
      .catch(() => {
        setCommonError(messages('error_something_wrong_on_details_request'));
      });
  };

  const handleBack = () => {
    fireGtmEvent('homeOtpOtherPhone');
    setTokenReceived(false);
  };

  return (
    <OtpPopup
      open={open}
      tokenReceived={tokenReceived}
      commonErrorMessage={commonError}
      onClose={handleClose}
      handlePostOtpDetails={handlePostOtpDetails}
      clearError={() => setCommonError('')}
      handleVerify={handleVerify}
      handleResend={handleResend}
      handleBack={handleBack}
      otpMethods={otpMethods}
      tokenLoading={tokenLoading}
      verifyLoading={verifyLoading}
      showWhatsappButton
    />
  );
};

OtpContainer.propTypes = {
  handleBlocked: PropTypes.func,
  handleClose: PropTypes.func,
  handleVerified: PropTypes.func,
  intl: PropTypes.object,
  open: PropTypes.bool,
  otpMethods: PropTypes.array,
};

export default injectIntl(OtpContainer);
